<ng-template #loading>
  <div class="bee-loading-wrapper">
    <mat-progress-spinner
      mode="indeterminate">
    </mat-progress-spinner>
  </div>
</ng-template>

<bee-unit-information *ngIf="{unit: unit$ | async, adminUsers: adminUsers$ | async} as vm else loading" 
  [unit]="vm.unit" [unitAdministrators]="vm.adminUsers"></bee-unit-information>